// SessionRevokedListener — реакция на серверное событие `session:revoked`
// (бан, admin force-logout, смена пароля, security-инцидент).
//
// Сессия на сервере уже мертва, поэтому sign-out не дёргаем: чистим bearer и
// локальное auth-состояние, оповещаем соседние вкладки и уводим на вход.
// Событие приходит в комнату пользователя — см. shared/socket/socket.types.ts.
// Монтируется один раз в __root рядом с остальными глобальными слушателями.

import { toast } from "@studyhub/ui/toast";
import { useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { useSocketEvent } from "@/hooks/use-socket-event";
import { clearAccessToken } from "@/lib/auth-storage";
import { broadcastAuthEvent } from "@/providers/auth-provider";
import { useLoginModalStore } from "@/stores/login-modal";
import { useSessionStore } from "@/stores/session";

export function SessionRevokedListener(): null {
	const { t } = useTranslation("auth");
	const queryClient = useQueryClient();
	const navigate = useNavigate();

	useSocketEvent("session:revoked", (payload) => {
		clearAccessToken();
		useSessionStore.getState().logout();
		useLoginModalStore.getState().close();
		queryClient.removeQueries({ queryKey: ["auth", "me"] });
		broadcastAuthEvent("logout");

		toast.error(
			payload.reason === "password_changed"
				? t("sessionRevoked.passwordChanged")
				: t("sessionRevoked.body"),
		);
		void navigate({ to: "/auth/login", replace: true });
	});

	return null;
}
